import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
import { EmbedContext, defaultEmbedContextValue } from "./Context";
import { embedContextReducer } from "./reducer";
import { useEditableTemplateBoard, editableTemplatesConfig } from "../hooks/useEditableTemplateBoard";
var config = {
    editableTemplateBoard: {
        boardContainerConfig: {
            boardContainerWidth: "100%",
            boardContainerHeight: "100%",
            boardContainerTestId: "editable-template-board-container",
            initialMode: "inline"
        },
        iframeConfig: {
            preproductBaseUrl: "/pre-products/editable-templates/template",
            testId: "editable-board-preview-frame",
            title: "Editable board preview frame"
        }
    }
};
export var PreproductContextProvider = function(param) {
    var configType = param.configType, templateKey = param.templateKey, customConfig = param.customConfig, children = param.children;
    var iframeRef = useRef(null);
    var ref = useEditableTemplateBoard(templateKey !== null && templateKey !== void 0 ? templateKey : "", editableTemplatesConfig), isEditableTemplatesExperiment = ref.isEditableTemplatesExperiment, isEditableTemplateBoardActive = ref.isEditableTemplateBoardActive, editableTemplatePreview = ref.editableTemplatePreview;
    var ref1 = _sliced_to_array(React.useReducer(embedContextReducer, _object_spread({}, defaultEmbedContextValue, config[configType], customConfig)), 2), state = ref1[0], dispatch = ref1[1];
    return /*#__PURE__*/ _jsx(EmbedContext.Provider, {
        value: _object_spread_props(_object_spread({}, state), {
            iframeState: _object_spread_props(_object_spread({}, state.iframeState), {
                iframeRef: iframeRef
            }),
            boardContainerState: _object_spread_props(_object_spread({}, state.boardContainerState), {
                editableTemplates: {
                    isEditableTemplatesExperiment: isEditableTemplatesExperiment,
                    isEditableTemplateBoardActive: isEditableTemplateBoardActive,
                    editableTemplatePreview: editableTemplatePreview,
                    templateKey: templateKey !== null && templateKey !== void 0 ? templateKey : ""
                }
            }),
            dispatch: dispatch
        }),
        children: children
    });
};
